module.exports = __webpack_public_path__ + "img/167.d60e47f1.jpg";